import { Checkbox, Chip, MenuItem } from '@mui/material';
import { FormStatus } from 'api/models';
import ClearableSelect from 'components/ClearableSelect/ClearableSelect';
import { useTranslation } from 'react-i18next';

interface StatusSelectProps {
  loading?: boolean;
  value?: FormStatus[];
  onChange: (value: FormStatus[]) => void;
}

export default function StatusSelect({
  loading,
  value = [],
  onChange,
}: StatusSelectProps) {
  const { t } = useTranslation();
  const visibleStatuses = [FormStatus.Filling, FormStatus.Finalized];
  return (
    <ClearableSelect
      multiple
      fullWidth
      disabled={loading}
      label={t('general.status')}
      value={value}
      sx={{
        '& .MuiInputBase-root': {
          minHeight: '56px'
        },
      }}
      onChange={e => {
        onChange(e.target.value as any);
      }}
      renderValue={() => {
        return value?.map(s => (
          <Chip
            key={`status-selector:${s}-value-chip`}
            sx={{ mr: 1 }}
            label={t(`forms.status.${s}`)}
            color={'primary'}
          />
        ));
      }}
    >
      {visibleStatuses.map(s => (
        <MenuItem key={`${s}-status-menu-item`} value={s} disabled={loading}>
          <Checkbox checked={value.includes(s)} />
          {t(`forms.status.${s}`)}
        </MenuItem>
      ))}
    </ClearableSelect>
  );
}
